import React from 'react';
import { BannerType } from '../../sections/notification-banner/banner-type';
import { ExperienceType } from '../../sections/notification-banner/experience-type';
import { useNotificationBannerContent } from '../../sections/notification-banner/hooks/use-notification-banner';
import NotificationBanner from '../../sections/notification-banner/notification-banner';

interface Props {
    experience: ExperienceType;
    fragmentName: BannerType;
}
const WebFlashMessage = (props: Props) => {
    const experienceNotificationBannerContent = useNotificationBannerContent(
        props.experience,
        props.fragmentName
    );
    return (
        <>
            {experienceNotificationBannerContent &&
                experienceNotificationBannerContent.bannerText && (
                    <NotificationBanner
                        hide={experienceNotificationBannerContent?.hide}
                        type={experienceNotificationBannerContent?.type}
                        bannerDismissible={
                            experienceNotificationBannerContent?.bannerDismissible
                        }
                        dismissAriaLabel={
                            experienceNotificationBannerContent?.dismissAriaLabel
                        }
                        bannerText={
                            experienceNotificationBannerContent?.bannerText
                        }
                        showChevron={
                            experienceNotificationBannerContent?.showChevron
                        }
                    />
                )}
        </>
    );
};

export default WebFlashMessage;
